import axiosIns from '@/api/axios'

export const GET_LIST = () => {
  return axiosIns.get("https://api.ugems.id/hms/api/upresence/sick-leave");
};

export const DETAIL = (id) => {
  return axiosIns.get(`https://api.ugems.id/hms/api/upresence/sick-leave/${id}`);
};